import { render, staticRenderFns } from "./DistintaBaseAlt.vue?vue&type=template&id=e9e15a6e&scoped=true&"
import script from "./DistintaBaseAlt.vue?vue&type=script&lang=js&"
export * from "./DistintaBaseAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e15a6e",
  null
  
)

export default component.exports